import { render, staticRenderFns } from "./Seccion3View.vue?vue&type=template&id=e947305a&"
import script from "./Seccion3View.vue?vue&type=script&lang=js&"
export * from "./Seccion3View.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports